import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import './Hero.css';

const slides = [
  { id: 1, badge: 'Limited Time', title: 'Summer Sale', subtitle: 'Up to 70% off select styles', image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1400', ctaText: 'Shop Now', ctaLink: '/sale' },
  { id: 2, badge: 'New Arrivals', title: 'Fresh Summer Styles', subtitle: 'Discover the latest trends for the season', image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1400', ctaText: 'Explore', ctaLink: '/shop', light: true },
  { id: 3, badge: 'Star Rewards', title: 'Earn While You Shop', subtitle: 'Join Star Rewards and get 5% back in Star Money', image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1400', ctaText: 'Join Free', ctaLink: '/rewards' },
];

const promoCategories = [
  { id: 1, title: "Women's Styles", discount: 'Up to 60% Off', image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400', link: '/category/women' },
  { id: 2, title: "Men's Collection", discount: 'Up to 50% Off', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400', link: '/category/men' },
  { id: 3, title: 'Home Essentials', discount: 'Up to 40% Off', image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400', link: '/category/home' },
  { id: 4, title: 'Beauty Must-Haves', discount: 'Buy 2 Get 1 Free', image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400', link: '/category/beauty' },
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const nextSlide = useCallback(() => setCurrentSlide((prev) => (prev + 1) % slides.length), []);
  const prevSlide = useCallback(() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length), []);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  return (
    <section className="hero">
      <div className="hero-slider" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)}>
        {slides.map((slide, index) => (
          <div key={slide.id} className={`hero-slide ${index === currentSlide ? 'active' : ''}`}>
            <img src={slide.image} alt={slide.title} className="hero-slide-image" />
            <div className={`hero-slide-overlay ${slide.light ? 'light' : ''}`}>
              {slide.badge && <span className="hero-badge">{slide.badge}</span>}
              <h1 className="hero-title">{slide.title}</h1>
              <p className="hero-subtitle">{slide.subtitle}</p>
              <Link to={slide.ctaLink} className="hero-cta">
                {slide.ctaText}
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        ))}
        <button className="hero-nav prev" onClick={prevSlide}><ChevronLeft className="hero-nav-icon" /></button>
        <button className="hero-nav next" onClick={nextSlide}><ChevronRight className="hero-nav-icon" /></button>
        <div className="hero-dots">
          {slides.map((_, index) => (
            <button key={index} className={`hero-dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} />
          ))}
        </div>
      </div>
      <div className="hero-promo-banners">
        {promoCategories.map((promo) => (
          <Link key={promo.id} to={promo.link} className="hero-promo-card">
            <img src={promo.image} alt={promo.title} />
            <div className="hero-promo-overlay">
              <h3 className="hero-promo-title">{promo.title}</h3>
              <p className="hero-promo-discount">{promo.discount}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Hero;
